// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__l1RVs","options":"AnswerScale_options__qtamE","selected":"AnswerScale_selected__EUPzw"};